import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { UserDTO } from 'src/app/interfaces/user';

@Component({
    selector: 'app-page-not-found',
    imports: [],
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
})
export class PageNotFoundComponent implements OnInit {

  role: string;
  isOk: boolean = false;
  isLoggedIn = false;
  user: UserDTO;

  constructor(private tokenStorageService: TokenStorageService, private router: Router) { }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.role = this.user.role;
      this.isOk = true;
    } 
    if (this.isOk) {
      this.router.navigate(['notes']);
    } else {
      this.router.navigate(['home']);
    }
  }

  ngOnInit(): void {
    this.isAuthorized();
  }

}
